var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9997 0.083252C10.3434 0.083252 0.0830078 10.3437 0.0830078 22.9999C0.0830078 35.6562 10.3434 45.9166 22.9997 45.9166C35.6559 45.9166 45.9163 35.6562 45.9163 22.9999C45.9163 10.3437 35.6559 0.083252 22.9997 0.083252ZM32.933 19.1249C33.1159 18.9158 33.2552 18.6723 33.3426 18.4086C33.43 18.1449 33.4637 17.8664 33.4419 17.5895C33.4201 17.3125 33.3431 17.0428 33.2155 16.796C33.0878 16.5493 32.9121 16.3306 32.6987 16.1527C32.4853 15.9749 32.2385 15.8415 31.9728 15.7605C31.7071 15.6794 31.4278 15.6523 31.1515 15.6808C30.8752 15.7093 30.6073 15.7927 30.3637 15.9262C30.1201 16.0598 29.9057 16.2406 29.733 16.4583L20.7747 27.2062L16.1393 22.5687C15.7463 22.1892 15.2201 21.9792 14.6738 21.9839C14.1276 21.9887 13.6051 22.2078 13.2188 22.594C12.8325 22.9803 12.6134 23.5028 12.6087 24.0491C12.6039 24.5953 12.8139 25.1216 13.1934 25.5145L19.4434 31.7645C19.6481 31.9691 19.8932 32.1288 20.163 32.2334C20.4329 32.338 20.7215 32.3852 21.0107 32.3721C21.2998 32.359 21.583 32.2857 21.8422 32.1571C22.1014 32.0285 22.331 31.8472 22.5163 31.6249L32.933 19.1249Z",
    fill: "#2A455F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f56b1cd34253c03db4140eb017e2bc12.svg";
export { ForwardRef as ReactComponent };